<template>
  <div class="split-cta">
    <div class="split-cta-image">
      <MediaSlotImage
        slot-code="about.split_cta"
        :fallback="image"
        :alt="imageAlt"
        sizes="(max-width: 767px) 100vw, 50vw"
        :width="960"
        :height="1200"
      />
    </div>
    <div class="split-cta-content">
      <span class="section-eyebrow split-cta-eyebrow reveal">
        {{ eyebrow }}
      </span>
      <h2 class="split-cta-title reveal">
        Every frame.<br />Every face.<br />Every style.
      </h2>
      <p class="split-cta-body reveal">
        {{ body }}
      </p>
      <a :href="buttonLink" class="btn-primary split-cta-btn reveal">
        {{ buttonText }}
      </a>
    </div>
  </div>
</template>

<script>
import { cdnUrl } from "~/utils/cdn";
import MediaSlotImage from "~/core/components/atoms/media-slot-image/media-slot-image.vue";

export default {
  name: "AboutSplitCta",
  components: { MediaSlotImage },
  props: {
    image: {
      type: String,
      default: () => cdnUrl("/image/HOOLIGANS+WEB/About+Us/prada-cta.jpg"),
    },
    imageAlt: {
      type: String,
      default: "Shop Now",
    },
    eyebrow: {
      type: String,
      default: "Your perfect pair awaits",
    },
    body: {
      type: String,
      default:
        "From classic aviators to bold cat-eyes — explore hundreds of authentic designer frames in stock and ready to ship.",
    },
    buttonText: {
      type: String,
      default: "Shop Now",
    },
    buttonLink: {
      type: String,
      default: "/designer-eyewear",
    },
  },
};
</script>
